import { render } from "./CookiePolicy.vue?vue&type=template&id=02667e1e&scoped=true&lang=pug"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts"

import "./CookiePolicy.vue?vue&type=style&index=0&id=02667e1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02667e1e"

export default script